import { RESET_SUBMIT } from 'app/marketplace/SlideInBanners/CrmBanner/redux/constants';

// Clean up submission state
export const resetSubmit = () => ({ type: RESET_SUBMIT });
